import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  // `.grid-4` stat-tile row from the mockup's `#tab-adminprofile` — the small
  // set of headline fields (External Ref#, Member#, Status, Member Type)
  // called out as individual bordered tiles, same as Subscription's summary.
  statTileGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
    gap: 16,
    marginTop: 24,
    marginBottom: 28,
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    maxHeight: 'calc(75vh - 150px)',
  },
  gridItem: {
    padding: '8px 10px',
    textAlign: 'left',
    display: 'flex',
    minHeight: 48,
  },
};

export default styles;
